<template>
  <div class="fahrzeug-data">

    <div class="semanticsection-title2 primary--text">Verkehrs-Rechtsschutz für Firmen/Selbstständige (§ 21 ARB)</div>

    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">PKW, Krad, Kombi
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlPkw"
                      v-validate="'required|numeric|min_value:0|fahrzeuganzahl'"
                      :error-messages="errors.collect('anzahlPkw')"
                      data-vv-as="Anzahl PKW"
                      data-vv-name="anzahlPkw"
                      placeholder="Anzahl PKW *"
                      hint="Anzahl PKW"
                      @input="$emit('pricechanged')" />
      </v-col>
    </v-row>

    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Nutzfahrzeuge bis 4 t Nutzlast
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlBis4t"
                      v-validate="'required|numeric|min_value:0|fahrzeuganzahl'"
                      :error-messages="errors.collect('anzahlBis4t')"
                      data-vv-as="Anzahl Nutzfahrzeuge bis 4t"
                      data-vv-name="anzahlBis4t"
                      placeholder="Anzahl Nutzfahrzeuge bis 4t *"
                      hint="Anzahl Nutzfahrzeuge bis 4t"
                      @input="$emit('pricechanged')" />
      </v-col>
    </v-row>

    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Omnibusse bis 9 Sitze
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlBis9sitze"
                      v-validate="'required|numeric|min_value:0|fahrzeuganzahl'"
                      :error-messages="errors.collect('anzahlBis9sitze')"
                      data-vv-as="Anzahl Omnibusse bis 9 Sitze"
                      data-vv-name="anzahlBis9sitze"
                      placeholder="Anzahl Omnibusse bis 9 Sitze *"
                      hint="Anzahl Omnibusse bis 9 Sitze"
                      @input="$emit('pricechanged')" />
      </v-col>
    </v-row>

    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Zugmaschinen (nicht Sattelzug)
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlZugmaschinen"
                      v-validate="'required|numeric|min_value:0|fahrzeuganzahl'"
                      :error-messages="errors.collect('anzahlZugmaschinen')"
                      data-vv-as="Anzahl Zugmaschinen"
                      data-vv-name="anzahlZugmaschinen"
                      placeholder="Anzahl Zugmaschinen *"
                      hint="Anzahl Zugmaschinen (ohne Sattelzüge)"
                      @input="$emit('pricechanged')" />
      </v-col>
    </v-row>

    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Sonderfahrzeuge und Arbeitsmaschinen
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlSonderfahrzeuge"
                      v-validate="'required|numeric|min_value:0|fahrzeuganzahl'"
                      :error-messages="errors.collect('anzahlSonderfahrzeuge')"
                      data-vv-as="Anzahl Sonderfahrzeuge"
                      data-vv-name="anzahlSonderfahrzeuge"
                      placeholder="Anzahl Sonderfahrzeuge *"
                      hint="Anzahl Sonderfahrzeuge"
                      @input="$emit('pricechanged')" />
      </v-col>
    </v-row>

    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Anhänger
        </span>
        <site-tooltip>
          Ab 5 Kraftfahrzeugen sind alle Anhänger beitragsfrei mitversichert.
        </site-tooltip>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlAnhaenger"
                      v-validate="'required|numeric|min_value:0|fahrzeuganzahl'"
                      :error-messages="errors.collect('anzahlAnhaenger')"
                      data-vv-as="Anzahl Anhänger"
                      data-vv-name="anzahlAnhaenger"
                      placeholder="Anzahl Anhänger *"
                      hint="Anzahl Anhänger"
                      @input="$emit('pricechanged')" />
      </v-col>
    </v-row>
    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Nutzfahrzeuge über 4 t Nutzlast
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlAb4t"
                      v-validate="'required|numeric|min_value:0|fahrzeuganzahl'"
                      :error-messages="errors.collect('anzahlAb4t')"
                      data-vv-as="Anzahl Nutzfahrzeuge über 4 t"
                      data-vv-name="anzahlAb4t"
                      placeholder="Anzahl Nutzfahrzeuge über 4 t *"
                      hint="Anzahl Nutzfahrzeuge über 4 t"
                      @input="$emit('pricechanged')" />
      </v-col>
    </v-row>
    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Omnibusse über 9 Sitze
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlAb9sitze"
                      v-validate="'required|numeric|min_value:0|fahrzeuganzahl'"
                      :error-messages="errors.collect('anzahlAb9sitze')"
                      data-vv-as="Anzahl Omnibusse über 9 Sitze"
                      data-vv-name="anzahlAb9sitze"
                      placeholder="Anzahl Omnibusse über 9 Sitze *"
                      hint="Anzahl Omnibusse über 9 Sitze"
                      @input="$emit('pricechanged')" />
      </v-col>
    </v-row>
    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Sattelzugmaschinen
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlSattelzugmaschinen"
                      v-validate="'required|numeric|min_value:0|fahrzeuganzahl'"
                      :error-messages="errors.collect('anzahlSattelzugmaschinen')"
                      data-vv-as="Anzahl Sattelzugmaschinen"
                      data-vv-name="anzahlSattelzugmaschinen"
                      placeholder="Anzahl Sattelzugmaschinen *"
                      hint="Anzahl Sattelzugmaschinen"
                      @input="$emit('pricechanged')" />
      </v-col>
    </v-row>
    <v-text-field
      v-show="false"
      v-validate:relevanteFahrzeuge="'min_value:1'"
      :value="0"
      :error-messages="errors.collect('AnzahlPositiv')"
      data-vv-name="AnzahlPositiv"
      class="hidden-validation-trigger" />
    <v-row v-if="anzahlNullError" no-gutters align="baseline">
      <v-col cols="12"
             sm="6"/>
      <v-col cols="12"
             sm="6"
             class="error--text" >
         {{ anzahlNullError }}            
      </v-col>
    </v-row>
  </div>
</template>

<script>
import twowayBindingMixin, { mapTwoWay } from '../../store/twowayBindingMixin';
import ValidationMixin from '../helper/ValidationMixin';
import {mapGetters} from "vuex";

export default {
  name: "FahrzeugData",
  mixins: [ twowayBindingMixin, ValidationMixin ],
  computed: {
    anzahlNullError: function() {
     let allempty = this.$validator.errors.items.reduce( (b, e) =>  b || (e.field === 'AnzahlPositiv'), false);
     return (allempty) ? "Bitte geben Sie die Anzahl der zu versichernden Fahrzeuge an." : "";
    },
    ...mapGetters(
    [
      'relevanteFahrzeuge'
    ]),
    ...mapTwoWay([
        'anzahlPkw',
        'anzahlBis4t',
        'anzahlBis9sitze',
        'anzahlZugmaschinen',
        'anzahlSonderfahrzeuge',
        'anzahlAnhaenger',
        'anzahlAb4t',
        'anzahlAb9sitze',
        'anzahlSattelzugmaschinen'
      ], {
      anzahlPkw: 'pkw.anzahl',
      anzahlBis4t: 'bis4t.anzahl',
      anzahlBis9sitze: 'bis9sitze.anzahl',
      anzahlZugmaschinen: 'zugmaschinen.anzahl',
      anzahlSonderfahrzeuge: 'sonderfahrzeuge.anzahl',
      anzahlAnhaenger: 'anhaenger.anzahl',
      anzahlAb4t: 'ab4t.anzahl',
      anzahlAb9sitze: 'ab9sitze.anzahl',
      anzahlSattelzugmaschinen: 'sattelzugmaschinen.anzahl'
    })
  },
  watch: {
    relevanteFahrzeuge() {
      this.$validator.validateAll().then((result) => {
        if(!result) fnError();
      });
      const fnError = (function(){
          const maxerror = this.errors.items.filter(
            (er) => er.rule === "fahrzeuganzahl");
          if( maxerror.length) {
            this.$store.dispatch('gewerbeShowDirektionsanfrage', {
              label: "Fahrzeuge",
              limit: 10
            });
          }
      }).bind(this);
    }
  },
  created() {
    this.$validator.extend('fahrzeuganzahl', {
      getMessage() {
        const limit = 10;
        return `Es können online bis zu ${limit} Fahrzeuge angegeben werden`;
      },
      validate: function (value) {
        if (!this.relevanteFahrzeuge) {
          return true;
        }
        if( value === "" || value === 0 || value === "0") {
          return true;
        }
        return !(value && this.relevanteFahrzeuge > 10);
      }.bind(this)
    });
  }
};
</script>
<style>
  .fahrzeug-data .v-input {
  max-width: 344px;
}
</style>
